import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { PostDriverBreakEntity } from '../../domain/entities/PostDriverBreakEntity'

export class PostDriverBreakModel extends PostDriverBreakEntity {
  driverId?: number

  constructor(dataDto: PostDriverBreakEntity) {
    super()
    mapEntityProperties<PostDriverBreakModel>(this, dataDto, {
      exclude: ['driver'],
      map: {
        driverId: dataDto.driver?.id,
        startAt: dataDto.startAt ? new Date(dataDto.startAt).toISOString() : undefined,
        endAt: dataDto.endAt ? new Date(dataDto.endAt).toISOString() : undefined
      }
    })
  }
}
